module.exports = __webpack_public_path__ + "img/avataricon.35881e41.png";